module.exports = __webpack_public_path__ + "img/IAR6.e33da2fd.png";